import React from "react";
import { Modal } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import './VerificationRequiredModal.css';
import 'components/common/ModalSuccesUpdate/ModalSuccesUpdate.css';

interface VerificationRequiredModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  message?: string;
}

const VerificationRequiredModal: React.FC<VerificationRequiredModalProps> = ({
  show,
  onHide,
  title,
  message,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="dm-content"
      backdropClassName="dm-backdrop"
    >
      <button
        type="button"
        className="dm-close"
        onClick={onHide}
        aria-label="Close"
      >
        <X size={18} />
      </button>
      <Modal.Body className="dm-body" style={{ paddingBottom: 16 }}>
        <div
          className="dm-icon"
          style={{
            background: "rgba(217, 119, 6, 0.1)",
            color: "#d97706",
            boxShadow: "0 0 0 8px rgba(217, 119, 6, 0.08)",
          }}
        >
          <FaExclamationTriangle size={24} />
        </div>
        <h2 className="dm-title">
          {title || "Verification Required"}
        </h2>
        <p className="dm-text" style={{ marginBottom: 12 }}>
          {message || "Please verify your domain to send messages, manage connections, view resumes, or perform professional candidate actions."}
        </p>
      </Modal.Body>
      <Modal.Footer className="dm-footer">
        <button
          type="button"
          className="dm-btn dm-btn-cancel"
          onClick={onHide}
        >
          Close
        </button>
        <button
          type="button"
          className="dm-btn dm-btn-primary"
          style={{ background: "#d97706", borderColor: "#d97706" }}
          onClick={() => {
            onHide();
            navigate("/business-verification");
          }}
        >
          Verify Now
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default VerificationRequiredModal;
